<template>
  <div class="container_DemandarForm">
    <ValidationObserver ref="formDemandar">
      <b-form>
        <div v-if="!phase5" class="form_DemandarForm">
          <b-row>
            <b-col
              md="7"
              lg="7"
              class="separator"
              :class="phase1 || phase2 || phase3 || phase4 ? '' : 'invisible'"
            >
              <div class="pl-2 pr-2">
                <b-card-title v-if="isEditar">
                  {{ $t("label.edicion.demanda") }}
                </b-card-title>
                <b-card-title v-else>{{ $t("label.creacion.demanda") }}</b-card-title>

                <!-- Phase 1 -->
                <b-row class="mt-5" v-if="phase1">
                  <b-col cols="1">
                    <b-button disabled pill variant="primary" class="btn-number font-weight-bold"
                      >1</b-button
                    >
                  </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      name="select-client"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-client"
                          name="select-client"
                          aria-describedby="select-client-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="getClientesAll"
                          v-model="clienteSelected"
                          label="desCliente"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.cliente')"
                          track-by="id"
                          @input="clienteSelectedInput"
                          :disabled="isEditar"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-client-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{ required: clienteSelected !== null && delegationSelected === null }"
                      name="select-delegation"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-delegation"
                          name="select-delegation"
                          aria-describedby="select-delegation-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="delegationsOptions"
                          v-model="delegationSelected"
                          label="desDelegacion"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.delegacion')"
                          track-by="id"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-delegation-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="phase1 && clienteSelected?.pais.hasTransportadora">
                  <b-col cols="1"> </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      name="select-transportadora"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-transportadora"
                          name="select-transportadora"
                          aria-describedby="select-transportadora-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="transportadorasOptions"
                          v-model="transportadoraSelected"
                          label="descripcion"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.transportadora')"
                          track-by="id"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-transportadora-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="
                    phase1 && delegationSelected && clienteSelected?.pais.intercambioDelegaciones
                  "
                >
                  <b-col cols="1"></b-col>
                  <b-col lg="10" md="10">
                    <div class="label_TitleLeftToDelegacionesOpcionales">
                      {{ titleLeftToDelegacionesOpcionales }}
                    </div>
                    <PFormSelectTranslateItems
                      v-model="delegationsOptionalSelected"
                      :options="delegationsOptionalOptions"
                      optionValue="id"
                      optionText="desDelegacion"
                      :titleRight="$t('label.seleccionados')"
                      :titleLeft="$t('label.delegacion')"
                    ></PFormSelectTranslateItems>
                  </b-col>
                </b-row>
                <b-row class="mb-5" v-if="phase1">
                  <b-col cols="1"> </b-col>
                  <b-col lg="11" md="11" v-if="clienteSelected">
                    <span class="recent-label">{{ $t("label.divisa") }}</span>
                    <b-row>
                      <b-col>
                        <b-form-group v-if="clienteSelected">
                          <b-form-radio-group
                            v-model="divisaSelected"
                            buttons
                            button-variant="outline-primary"
                            class="mx-n1 radio-form-group"
                          >
                            <template v-for="divisa in divisas">
                              <b-form-radio
                                :value="divisa"
                                :key="divisa.id"
                                class="mx-1 form-radio"
                              >
                                {{ divisa.simbolo }} {{ divisa.codDivisa }}
                              </b-form-radio>
                            </template>
                          </b-form-radio-group>
                          <br />
                          <span
                            class="error-divisa"
                            v-if="clienteSelected && delegationSelected && !divisaSelected"
                            >{{ $t("validation.messages.required") }}</span
                          >
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 2 -->
                <b-row class="mt-5" v-if="phase2">
                  <b-col cols="1">
                    <b-button disabled pill variant="primary" class="btn-number font-weight-bold"
                      >2</b-button
                    >
                  </b-col>
                  <b-col lg="5" md="5" v-if="!clienteSelected?.fakeCerts">
                    <span class="recent-label">{{ $t("label.denominaciones.disponibles") }}</span>
                  </b-col>
                  <b-col lg="5" md="5">
                    <span class="recent-label">{{ $t("label.denominaciones.demandar") }}</span>
                  </b-col>
                </b-row>

                <b-row class="mt-3 mb-5" v-if="phase2">
                  <b-col v-if="!clienteSelected?.fakeCerts">
                    <b-card class="m-0">
                      <b-card-header>
                        <b-row>
                          <b-col>
                            <span class="recent-label">{{
                              $t("label.saldo.total.disponible")
                            }}</span>
                            <br />
                            <span class="recent-label font-weight-bold"
                              >{{ divisaSelected.simbolo }}
                              {{ filterNumber(saldoDisponible, 2) }}</span
                            >
                            <b-icon
                              class="float-right mt-2"
                              icon="chevron-down"
                              v-b-toggle.card-body-denominaciones
                            ></b-icon>
                          </b-col>
                        </b-row>
                      </b-card-header>
                      <b-collapse
                        class="panel-denominaciones"
                        visible
                        id="card-body-denominaciones"
                      >
                        <b-card-text>
                          <b-row class="ma-1">
                            <b-col lg="6" md="6">
                              <b-card-title class="align-center">{{
                                $t("label.denominacion")
                              }}</b-card-title>
                            </b-col>
                            <b-col lg="6" md="6">
                              <b-card-title>{{ $t("label.disponible") }}</b-card-title>
                            </b-col>
                          </b-row>
                          <div v-for="detalleSaldo in detallesSaldo" :key="detalleSaldo.id">
                            <hr />
                            <b-row>
                              <b-col>
                                <span
                                  >{{
                                    detalleSaldo.calidadDenominacion.denominacion.codDenominacion
                                  }}
                                  {{ detalleSaldo.calidadDenominacion.desCalidad }}</span
                                >
                              </b-col>
                              <b-col>
                                <span>{{ filterNumber(detalleSaldo.saldoActual, 2) }}</span>
                              </b-col>
                            </b-row>
                          </div>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                  </b-col>
                  <b-col>
                    <b-row class="mt-3">
                      <b-col>
                        <span class="recent-label">{{ $t("label.total.demandar") }}</span>
                        <br />
                        <span class="recent-label font-weight-bold"
                          >{{ divisaSelected.simbolo }} {{ filterNumber(saldoDemandar, 2) }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row class="mt-3">
                      <b-col>
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="'required'"
                          name="select-denominacion"
                        >
                          <b-form-group>
                            <multiselect
                              id="select-denominacion"
                              name="select-denominacion"
                              v-model="calidadesDenominacionSelected"
                              aria-describedby="select-denominacion-feedback"
                              :options="calidadesDenominacion"
                              :custom-label="customLabelDenominacion"
                              :clear-on-select="false"
                              :close-on-select="false"
                              :multiple="true"
                              :preserve-search="false"
                              select-label=""
                              deselect-label=""
                              selected-label=""
                              :state="errors[0] ? false : null"
                              :placeholder="$t('option.select')"
                              track-by="id"
                            >
                              <span slot="noOptions">{{ $t("text.no.options") }}</span>
                              <span slot="noResult">{{ $t("text.no.results") }}</span>
                              <template v-slot:option="{ option }">
                                <div>
                                  <span
                                    >{{ option.denominacion.codDenominacion }}
                                    {{ option.desCalidad }}</span
                                  >
                                </div>
                              </template>
                            </multiselect>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row
                      class="mt-3"
                      v-if="
                        calidadesDenominacionSelected && calidadesDenominacionSelected.length > 0
                      "
                    >
                      <b-col>
                        <b-row>
                          <b-col lg="6" md="6">
                            <span class="recent-label">{{ $t("label.importe.demandar") }}</span>
                          </b-col>
                          <b-col lg="3" md="3" class="label-demandado">
                            <b-card-title>{{ $t("label.demandado") }}</b-card-title>
                          </b-col>
                          <b-col lg="3" md="3" class="label-demandado">
                            <b-card-title>{{ $t("label.cantidad") }}</b-card-title>
                          </b-col>
                        </b-row>
                        <div
                          v-for="(calidadDenominacion, index) in calidadesDenominacionSelected"
                          :key="calidadDenominacion.id"
                        >
                          <hr />
                          <b-row>
                            <b-col>
                              <span
                                >{{ calidadDenominacion.denominacion.codDenominacion }}
                                {{ calidadDenominacion.desCalidad }}</span
                              >
                            </b-col>
                            <b-col> </b-col>
                            <b-col mr="3">
                              <span
                                class="denominacion-importe float-right"
                                v-b-toggle="
                                  `calidadDenominacion-${calidadDenominacion.id.toString()}`
                                "
                                @click="
                                  (calidadDenominacion.importeSelected = true),
                                    (calidadDenominacion.cantidadSelected = false)
                                "
                                >{{ divisaSelected.simbolo }}
                                {{ filterNumber(calidadDenominacion.importe, 2) }}</span
                              >
                            </b-col>
                            <b-col mr="3">
                              <span
                                class="denominacion-importe float-right"
                                v-b-toggle="`cantidad-${calidadDenominacion.id.toString()}`"
                                @click="
                                  (calidadDenominacion.importeSelected = false),
                                    (calidadDenominacion.cantidadSelected = true)
                                "
                              >
                                {{ calidadDenominacion.cantidad }}</span
                              >
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :rules="`valid-denomination:${calidadDenominacion.denominacion.numValue}|min_value:0`"
                                :name="`cantidad-denominacion_${index}`"
                              >
                                <b-collapse
                                  :id="`calidadDenominacion-${calidadDenominacion.id.toString()}`"
                                  v-if="
                                    calidadDenominacion.importeSelected &&
                                    !calidadDenominacion.cantidadSelected
                                  "
                                >
                                  <b-card class="input-card">
                                    <b-card-body>
                                      <b-row>
                                        <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                          <b-form-group>
                                            <b-input
                                              type="number"
                                              min="0"
                                              max="999999999"
                                              :step="calidadDenominacion.denominacion.numValue"
                                              v-model="calidadDenominacion.importe"
                                              :name="`cantidad-denominacion_${index}`"
                                              :id="`cantidad-denominacion_${index}`"
                                              :state="errors[0] ? false : null"
                                              :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                              @change="calculaCantidad(calidadDenominacion)"
                                            />
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-input
                                        type="range"
                                        min="0"
                                        max="999999999"
                                        :step="calidadDenominacion.denominacion.numValue"
                                        v-model="calidadDenominacion.importe"
                                        class="mt-1"
                                        @click="calculaCantidad(calidadDenominacion)"
                                      />
                                    </b-card-body>
                                  </b-card>
                                </b-collapse>
                                <b-form-invalid-feedback
                                  :id="`cantidad-denominacion-feedback_${index}`"
                                  class="d-block"
                                >
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </ValidationProvider>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :rules="`min_value:0|integer`"
                                :name="`cantidad_${index}`"
                              >
                                <b-collapse
                                  :id="`cantidad-${calidadDenominacion.id.toString()}`"
                                  v-if="
                                    !calidadDenominacion.importeSelected &&
                                    calidadDenominacion.cantidadSelected
                                  "
                                >
                                  <b-card class="input-card">
                                    <b-card-body>
                                      <b-row>
                                        <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                          <b-form-group>
                                            <b-input
                                              type="number"
                                              min="0"
                                              max="1666666"
                                              :step="1"
                                              v-model="calidadDenominacion.cantidad"
                                              :name="`cantidad_${index}`"
                                              :id="`cantidad_${index}`"
                                              :state="errors[0] ? false : null"
                                              :aria-describedby="`cantidad-feedback_${index}`"
                                              @change="calculaImporte(calidadDenominacion)"
                                            />
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-input
                                        type="range"
                                        min="0"
                                        max="1666666"
                                        :step="1"
                                        v-model="calidadDenominacion.cantidad"
                                        class="mt-1"
                                        @click="calculaImporte(calidadDenominacion)"
                                      />
                                    </b-card-body>
                                  </b-card>
                                </b-collapse>
                                <b-form-invalid-feedback
                                  :id="`cantidad-feedback_${index}`"
                                  class="d-block"
                                >
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 3 -->
                <b-row class="mt-5" style="margin-bottom: 5rem" v-if="phase3">
                  <b-col>
                    <b-row>
                      <b-col cols="1">
                        <b-button
                          disabled
                          pill
                          variant="primary"
                          class="btn-number font-weight-bold"
                          >3</b-button
                        >
                      </b-col>
                      <b-col>
                        <b-row class="mb-4" v-if="!clienteSelected?.pais.hasTransportadora">
                          <b-col lg="5" md="5">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'required'"
                              name="select-fecha-expiracion"
                            >
                              <b-form-group>
                                <label class="recent-label" for="select-fecha-expiracion">
                                  {{ $t("label.fecha.expiracion") }}
                                </label>
                                <b-form-datepicker
                                  id="select-fecha-expiracion"
                                  name="select-fecha-expiracion"
                                  v-model="fechaExpiracion"
                                  :state="errors[0] ? false : null"
                                  aria-describedby="fecha-expiracion-feedback"
                                  type="date"
                                  :min="
                                    new Date(
                                      new Date().getFullYear(),
                                      new Date().getMonth(),
                                      new Date().getDate()
                                    )
                                  "
                                  :date-format-options="{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  }"
                                />
                                <b-form-invalid-feedback id="fecha-expiracion-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row class="mb-4" v-if="!clienteSelected?.pais.hasTransportadora">
                          <b-col lg="5" md="5">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'required|date_future'"
                              name="select-hora-expiracion"
                            >
                              <b-form-group>
                                <label class="recent-label d-block" for="select-hora-expiracion">
                                  {{ $t("label.hora.expiracion") }}
                                </label>
                                <b-time
                                  id="select-hora-expiracion"
                                  name="select-hora-expiracion"
                                  v-model="horaExpiracion"
                                  :state="errors[0] ? false : null"
                                  aria-describedby="fecha-hora-feedback"
                                  :hide-header="true"
                                  :class="errors[0] ? 'is-invalid' : null"
                                />
                                <b-form-invalid-feedback id="fecha-hora-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <label class="recent-label" for="radio-coste">
                              {{ $t("label.coste") }}
                            </label>
                          </b-col>
                          <b-col v-if="clienteSelected?.pais.hasTasa">
                            <label class="recent-label" for="select-tasa">
                              {{ $t("label.tasa") }}
                            </label>
                          </b-col>
                        </b-row>
                        <b-row class="mb-4">
                          <b-col>
                            <b-form-group>
                              <b-form-radio-group
                                v-model="costeSelected"
                                buttons
                                button-variant="outline-primary"
                                class="mx-n1"
                                id="radio-coste"
                              >
                                <template v-for="coste in getCostes">
                                  <b-form-radio :value="coste" :key="coste.id" class="mx-1">
                                    {{ coste.codParametro }}
                                  </b-form-radio>
                                </template>
                              </b-form-radio-group>
                            </b-form-group>
                          </b-col>
                          <b-col
                            v-if="
                              clienteSelected?.pais.hasTasa && !clienteSelected?.pais.hasTasaEnteros
                            "
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'between:0,100|required'"
                              name="select-tasa"
                            >
                              <b-form-group>
                                <b-input-group append="%" :class="errors[0] ? 'is-invalid' : null">
                                  <b-form-input
                                    id="select-tasa"
                                    type="number"
                                    append="%"
                                    min="0"
                                    max="100"
                                    step="0.00001"
                                    v-model="tasa"
                                    name="select-tasa"
                                    :state="errors[0] ? false : null"
                                    aria-describedby="tasa-feedback"
                                  ></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="tasa-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col
                            v-if="
                              clienteSelected?.pais.hasTasa && clienteSelected?.pais.hasTasaEnteros
                            "
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'required|regex:^\\d+$|between:0,12'"
                              name="select-tasa"
                            >
                              <b-form-group>
                                <b-input-group
                                  append="x 10.000"
                                  :class="errors[0] ? 'is-invalid' : null"
                                >
                                  <b-form-input
                                    id="select-tasa"
                                    type="number"
                                    append="x 10.000"
                                    min="0"
                                    max="12"
                                    step="1"
                                    v-model="tasa"
                                    name="select-tasa"
                                    :state="errors[0] ? false : null"
                                    aria-describedby="tasa-feedback"
                                  ></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="tasa-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col v-if="clienteSelected?.pais.admiteAnonimo">
                            <b-form-group>
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="inputAnonimo"
                                  v-model="anonimo"
                                />
                                <label class="custom-control-label" for="inputAnonimo">
                                  {{ $t("label.demanda.anonima") }}
                                </label>
                              </div>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group>
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="inputParcial"
                                  v-model="parcial"
                                />
                                <label class="custom-control-label" for="inputParcial">
                                  {{ $t("label.demanda.parcial") }}
                                </label>
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 4 -->
                <b-row class="mt-4" style="margin-bottom: 5rem" v-if="phase4">
                  <b-col>
                    <div v-if="isShowBankField">
                      <b-row>
                        <b-col cols="1">
                          <b-button
                            disabled
                            pill
                            variant="primary"
                            class="btn-number font-weight-bold"
                            >4</b-button
                          ></b-col
                        >
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:14|cuenta_corriente_pattern"
                            name="cuentaCorriente"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.cuentaCorriente") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="cuentaCorriente"
                                  name="cuentaCorriente"
                                  v-model="demandaPaso4Params.cuentaCorriente"
                                  aria-describedby="cuenta_corriente-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="cuenta_corriente-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:11|ag_numero_sucursal_pattern"
                            name="agNumeroSucursal"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.agNumeroSucursal") }}</span>

                              <b-row class="mt-10">
                                <b-input
                                  id="agNumeroSucursal"
                                  name="agNumeroSucursal"
                                  v-model="demandaPaso4Params.agNumeroSucursal"
                                  aria-describedby="ag_numero_sucursal-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="ag_numero_sucursal-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|length:11|numeric"
                            name="ispbBanco"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.ispbBanco") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="ispbBanco"
                                  name="ispbBanco"
                                  v-model="demandaPaso4Params.ispbBanco"
                                  aria-describedby="ispb_banco-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="ispb_banco-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:18|cnpj_persona_pattern"
                            name="cnpjPersona"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.cnpjPersona") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="cnpjPersona"
                                  name="cnpjPersona"
                                  v-model="demandaPaso4Params.cnpjPersona"
                                  aria-describedby="cnpj_persona-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="cnpj_persona-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row>
                      <b-col cols="1"> </b-col>
                      <b-col lg="10" md="10" class="">
                        <b-form-group>
                          <span class="recent-label">{{ $t("label.observaciones") }}</span>
                        </b-form-group>
                        <b-row class="mt-10">
                          <textarea
                            class="textarea"
                            id="observacionesOferta"
                            v-model="demandaPaso4Params.observacionesDemanda"
                            name="observacionesOferta"
                            type="text"
                          />
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 5 -->
                <b-row class="mt-5" v-if="phase5"> </b-row>

                <b-row v-if="!phase5" class="modal-transferencias-footer">
                  <b-col v-if="!phase1">
                    <b-button
                      pill
                      variant="outline-primary"
                      class="p-button-secondary"
                      @click="atras"
                    >
                      {{ $t("label.atras") }}
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      pill
                      variant="primary"
                      class="p-button-primary"
                      :disabled="continuarCondition"
                      @click="continuar"
                    >
                      {{ $t("label.continuar") }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col md="5" lg="5">
              <div class="pl-2 pr-3">
                <resumen-demanda
                  :cliente="clienteSelected"
                  :delegacion="delegationSelected"
                  :transportadora="transportadoraSelected"
                  :divisa="divisaSelected"
                  :calidadesDenominacion="calidadesDenominacionSelected"
                  :saldoDemandar="saldoDemandar"
                  :fechaExpiracion="fechaExpiracion"
                  :horaExpiracion="horaExpiracion"
                  :coste="costeSelected"
                  :anonimo="anonimo"
                  :parcial="parcial"
                  :tasa="tasa"
                  :demandaPaso4Params="demandaPaso4Params"
                  :final="phase5"
                ></resumen-demanda>
                <div v-if="phase5">
                  <b-row class="mt-5">
                    <b-col class="text-right">
                      <b-button
                        pill
                        variant="outline-primary"
                        class="p-button-secondary mr-4"
                        @click="atras"
                      >
                        {{ $t("label.modificar") }}
                      </b-button>
                      <b-button
                        pill
                        variant="primary"
                        class="p-button-primary"
                        @click="infoDemandar"
                      >
                        {{ $t("label.demandar") }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="phase5">
          <PConfirm :textButtonAccept="$t('label.demandar')" @accept="demandar" @cancel="cancelar">
            <template #title>
              <span class="label-21">
                {{ $t("label.solicitar.fondos") }}
                <span class="font-weight-bold"> {{ delegationSelected.desDelegacion }}</span>
              </span>
            </template>
            <template #description>
              {{ demandaDescription }}
            </template>
            <template #content>
              <b-card v-if="hasDetectedChanges" class="changes-content mb-4">
                <b-card-body class="alert m-3">
                  <h5 class="alert-heading">{{ $t("label.cambios.detectados") }}</h5>
                  <div v-html="changesHtmlContent" class="changes-list"></div>
                </b-card-body>
              </b-card>
              <b-card v-else-if="isEditar && !hasDetectedChanges" class="mb-4">
                <b-card-body class="alert m-3">
                  <h5 class="alert-heading">{{ $t("label.sin.cambios") }}</h5>
                  <p>{{ $t("label.no.cambios.detectados") }}</p>
                </b-card-body>
              </b-card>
              <PDataLine
                v-if="divisaSelected"
                :value="{
                  saldoDemandar: divisaSelected.simbolo + ' ' + filterNumber(saldoDemandar, 2),
                }"
                :fields="{
                  saldoDemandar: { title: $t('label.total.demandar') },
                }"
                :widthContent="true"
              >
              </PDataLine>
            </template>
          </PConfirm>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ResumenDemanda from "./ResumenDemanda.vue";
import {
  ActionOnOfertaDemanda,
  ICalidadDenominacion,
  ICliente,
  IDelegacion,
  IDenominacion,
  IDetallesSaldo,
  IDivisa,
  IOfertaDemanda,
  IParametro,
  ISaldo,
  ITransportadora,
} from "@/entities";
import Multiselect from "vue-multiselect";
import { Action, Getter } from "vuex-class";
import {
  IDemandaParams,
  IDemandaPaso4Params,
  IDetalleDemandaParams,
  ISaldoActualParams,
} from "@/services";
import { EventBus } from "@/event-bus";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import AsyncComputed from "vue-async-computed-decorator";
import VueMethods from "@/vue-methods";
import VueFilters from "@/vue-filters";
import * as mathjs from "mathjs";
import { PConfirm, PDataLine } from "@/components/look";

@Component({
  name: "demandar-form",
  mixins: [VueMethods, VueFilters],
  components: {
    ResumenDemanda,
    Multiselect,
    ValidationObserver,
    ValidationProvider,
    PConfirm,
    PDataLine,
  },
})
export default class DemandarForm extends Vue {
  @Action("fetchSaldoActual") fetchSaldoActual!: (
    params?: ISaldoActualParams
  ) => Promise<ISaldo | undefined>;
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getClientesAll") getClientesAll!: ICliente[];
  @Getter("getCostes") getCostes!: IParametro[];
  @Prop({ required: false, default: "crear" }) readonly actionSource!: string;
  @Prop({ required: false, default: null }) readonly ofertaDemanda!: IOfertaDemanda;

  $refs!: {
    formDemandar: InstanceType<typeof ValidationObserver>;
  };

  public phase1 = true;
  public phase2 = false;
  public phase3 = false;
  public phase4 = false;
  public phase5 = false;

  public clienteSelected: ICliente | null = null;
  public delegationSelected: IDelegacion | null = null;
  public transportadoraSelected: ITransportadora | null = null;
  public divisaSelected: IDivisa | null = null;

  public saldoActual: ISaldo | null = null;
  public denominaciones: IDenominacion[] | undefined = [];
  public calidadesDenominacionSelected: ICalidadDenominacion[] | undefined = [];
  public detallesSaldo: IDetallesSaldo[] | undefined = [];
  public saldoDisponible: number | undefined = 0;
  public transportadorasOptions: ITransportadora[] | null = [];

  public costeSelected: IParametro | null = null;
  public fechaExpiracion: string | null = null;
  public horaExpiracion: string | null = null;
  public anonimo = false;
  public parcial = false;
  public tasa: number | undefined = 0;
  isShowBankField = false;

  delegationsOptionalSelected: number[] = [];

  hasDetectedChanges = false;
  changesHtmlContent = "";

  demandaPaso4Params: IDemandaPaso4Params = {
    relleno: false,
    cuentaCorriente: "",
    agNumeroSucursal: "",
    ispbBanco: "",
    cnpjPersona: "",
    observacionesDemanda: "",
  };
  demandaParams: IDemandaParams | null = null;

  get delegationsOptionalOptions(): IDelegacion[] {
    return this.delegationsOptions.filter((del) => del.id != this.delegationSelected?.id);
  }

  private get delegationsIdsOptional(): number[] {
    return this.delegationsOptionalSelected.filter((id) => id != this.delegationSelected?.id);
  }

  get divisas(): IDivisa[] {
    return this.clienteSelected?.divisas ?? [];
  }

  async searchTransportadoras(): Promise<void> {
    if (this.clienteSelected?.pais.hasTransportadora) {
      const res = await this.$services.transportadoras.fetchAllTransportadorasByCodPaisCorto(
        this.clienteSelected.pais.codPaisCorto
      );
      if (res) {
        this.transportadorasOptions = res;
      }
    }
  }

  async mounted(): Promise<void> {
    this.validateFechaAndHoraExpriracion();
    if (this.ofertaDemanda && this.isEditar) {
      await this.setupEditarDemanda();
    } else {
      this.clienteSelected = this.getClienteSelected;
    }
    await this.searchTransportadoras();
  }

  validateFechaAndHoraExpriracion(): void {
    extend("date_future", {
      validate: async () => {
        if (this.fechaExpiracion && this.horaExpiracion) {
          return (
            new Date(
              Number(this.fechaExpiracion.split("-")[0]),
              Number(this.fechaExpiracion.split("-")[1]) - 1,
              Number(this.fechaExpiracion.split("-")[2]),
              Number(this.horaExpiracion.split(":")[0]),
              Number(this.horaExpiracion.split(":")[1])
            ) > new Date()
          );
        }
        return false;
      },
      message: () => this.$t("validation.messages.date_must_future"),
    });
  }

  async setupEditarDemanda(): Promise<void> {
    const cliente = this.getClientesAll.find(
      (cli) => cli.id === this.ofertaDemanda.clientexdel.cliente.id
    );
    if (cliente) {
      this.clienteSelected = cliente ?? null;
      await this.clienteSelectedInput();
      this.delegationSelected = this.ofertaDemanda.clientexdel.delegacion;
      this.divisaSelected = this.divisas.find(
        (divisa) => divisa.id === this.ofertaDemanda.divisa.id
      )!;
      this.transportadoraSelected =
        this.transportadorasOptions?.find(
          (transportadora) => transportadora.id === this.ofertaDemanda.transportadora?.id
        ) || null;
      this.delegationsOptionalSelected =
        this.ofertaDemanda.ubicaciones
          ?.filter((ubicacion) => ubicacion.delegacion.id !== this.delegationSelected?.id)
          .map((ubicacion) => ubicacion.delegacion.id) || [];
      // Step 2
      await this.loadDetallesDemandaForEdit();
      // Step 3
      // obtener fecha de timestamp en formato yyyy-MM-dd
      const formatDate = (date: Date): string =>
        `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")}`;
      const fecFormateada = formatDate(new Date(this.ofertaDemanda.fecExpirar!));
      this.fechaExpiracion = fecFormateada;
      // obtener hora de timestamp en formato HH:mm:ss
      const formatTime = (date: Date): string =>
        `${date.getHours().toString().padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
      const horaFormateada = formatTime(new Date(this.ofertaDemanda.fecExpirar!));
      this.horaExpiracion = horaFormateada;
      const coste = this.getCostes.find(
        (c) =>
          c.codTipo === this.ofertaDemanda?.coste.codTipo &&
          c.codParametro === this.ofertaDemanda?.coste.codParametro
      );
      this.costeSelected = coste ?? null;
      this.anonimo = this.ofertaDemanda.checkAnonimo ?? false;
      this.parcial = this.ofertaDemanda.checkParcial ?? false;

      const transformTasa = (numTasa: number): number => {
        return Math.round(numTasa * 100000);
      };
      this.tasa = transformTasa(this.ofertaDemanda.numTasa ?? 0);
      // Step 4
      this.demandaPaso4Params = {
        relleno: true,
        cuentaCorriente: this.ofertaDemanda.cuentaCorriente ?? "",
        agNumeroSucursal: this.ofertaDemanda.agNumeroSucursal ?? "",
        ispbBanco: this.ofertaDemanda.ispbBanco ?? "",
        cnpjPersona: this.ofertaDemanda.cnpjPersona ?? "",
        observacionesDemanda: this.ofertaDemanda.observaciones ?? "",
      };
    }
  }

  get delegationsOptions(): IDelegacion[] {
    const d: IDelegacion[] = [];

    if (this.clienteSelected?.clientexdels) {
      this.clienteSelected?.clientexdels?.forEach((clientexdel) => {
        if (clientexdel?.delegacion && clientexdel.active) {
          d.push(clientexdel.delegacion);
        }
      });
      return d.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
    }
    return [];
  }

  async clienteSelectedInput(): Promise<void> {
    let aux = await this.$services.clientes._fetchCliente(Number(this.clienteSelected?.id));
    if (aux) {
      this.clienteSelected = aux;
      this.isShowBankField = aux.pais.hasInfoBancaria;
    }
    this.delegationSelected = null;
    this.divisaSelected = null;
    this.transportadoraSelected = null;
    await this.searchTransportadoras();
  }

  get calidadesDenominacion(): ICalidadDenominacion[] {
    const calidades: ICalidadDenominacion[] = [];
    const denominaciones = Object.assign([], this.divisaSelected?.denominaciones);
    denominaciones?.sort((a, b) => this.sortDescending(a, b, "numValue"));
    denominaciones?.forEach((denominacion: IDenominacion) => {
      denominacion.calidades?.forEach((calidad) => {
        if (calidad) {
          this.$set(calidad, "importe", 0);
          this.$set(calidad, "importeSelected", false);
          this.$set(calidad, "cantidad", 0);
          this.$set(calidad, "cantidadSelected", false);
          calidades.push(calidad);
        }
      });
    });
    return calidades;
  }

  async searchSaldosActuales(): Promise<void> {
    if (this.clienteSelected && this.delegationSelected && this.divisaSelected) {
      const res = await this.fetchSaldoActual({
        pkCliente: this.clienteSelected.id!,
        pkDelegacion: this.delegationSelected.id,
        pkDivisa: this.divisaSelected.id,
      });
      if (res) {
        this.saldoActual = res;
        if (this.saldoActual) {
          this.saldoDisponible = this.saldoActual.saldoActual;
          this.detallesSaldo = this.saldoActual.detallesSaldo;
          this.denominaciones = this.saldoActual.divisa.denominaciones;
          this.denominaciones.forEach((denominacion) => {
            denominacion.calidades.forEach((calidad) => {
              if (calidad) {
                this.$set(calidad, "importe", 0);
                this.calidadesDenominacion?.push(calidad);
              }
            });
          });
        }
      } else {
        EventBus.$emit("p-toast", { variant: "danger", message: res });
      }
    }
  }

  fechaDefecto(): void {
    const currentDate = new Date();

    const formatDate = (date: Date): string =>
      `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}`;

    this.fechaExpiracion = formatDate(currentDate);
    this.horaExpiracion = this.clienteSelected?.expirationTime ?? "17:00:00";

    const fechaHoraExpiracion = new Date(`${this.fechaExpiracion}T${this.horaExpiracion}`);

    if (currentDate.getTime() > fechaHoraExpiracion.getTime()) {
      currentDate.setDate(currentDate.getDate() + 1);
      this.fechaExpiracion = formatDate(currentDate);
    }
  }

  customLabelDenominacion(denominacion: ICalidadDenominacion): string {
    return denominacion?.denominacion?.codDenominacion + " " + denominacion?.desCalidad;
  }

  get saldoDemandar(): number {
    let sumaImportes = 0;
    this.calidadesDenominacionSelected?.forEach((calidadDenominacion) => {
      if (calidadDenominacion.importe) {
        sumaImportes = Number(sumaImportes) + Number(calidadDenominacion.importe);
      }
    });

    return sumaImportes;
  }

  get contieneImporte(): boolean {
    return !this.calidadesDenominacionSelected?.some((calidad) => calidad.importe == 0);
  }

  @AsyncComputed()
  async continuarCondition(): Promise<boolean> {
    if (this.phase1) {
      return false;
    } else if (this.phase2) {
      if (
        this.saldoDemandar > 0 &&
        this.contieneImporte &&
        this.calidadesDenominacionSelected &&
        this.calidadesDenominacionSelected?.length > 0 &&
        (await this.$refs.formDemandar.validate())
      ) {
        return false;
      }
    } else if (this.phase3) {
      if (
        this.fechaExpiracion &&
        this.horaExpiracion &&
        this.costeSelected &&
        (await this.$refs.formDemandar.validate({ silent: true }))
      ) {
        return false;
      }
    } else if (this.phase4) {
      if (await this.$refs.formDemandar.validate({ silent: true })) {
        return false;
      }
    } else if (this.phase5) {
      await this.infoDemandar();
    }

    return true;
  }

  atras(): void {
    if (this.phase2) {
      this.phase1 = true;
      this.phase2 = false;
      if (!this.isEditar) {
        this.calidadesDenominacionSelected = [];
      }
    } else if (this.phase3) {
      this.phase2 = true;
      this.phase3 = false;
      if (!this.isEditar) {
        this.fechaExpiracion = null;
        this.horaExpiracion = null;
        this.costeSelected = null;
      }
      this.anonimo = false;
      this.parcial = false;
    } else if (this.phase4) {
      this.phase3 = true;
      this.phase4 = false;
      if (!this.isEditar) {
        this.limpiarDemandaPaso4();
      }
    } else if (this.phase5) {
      this.phase4 = true;
      this.phase5 = false;
    } else if (!this.phase1 && !this.phase2 && !this.phase3 && !this.phase4 && !this.phase5) {
      this.phase5 = true;
    }
  }

  async continuar(): Promise<void> {
    if (this.phase1) {
      if ((await this.$refs.formDemandar.validate({ silent: true })) && this.divisaSelected) {
        this.phase1 = false;
        this.phase2 = true;
        if (!this.clienteSelected?.fakeCerts && !this.isEditar) {
          await this.searchSaldosActuales();
        }
      }
    } else if (this.phase2) {
      this.phase2 = false;
      this.phase3 = true;
      if (!this.isEditar) {
        this.fechaDefecto();
      }
    } else if (this.phase3) {
      this.phase3 = false;
      this.phase4 = true;
      this.demandaPaso4Params.relleno = true;
    } else if (this.phase4) {
      this.phase4 = false;
      this.phase5 = true;
    }
  }

  cancelar(): void {
    this.phase5 = false;
    this.phase4 = true;
    this.clearChangesState();
  }

  async infoDemandar(): Promise<void> {
    const detallesDemanda: IDetalleDemandaParams[] = [];
    this.calidadesDenominacionSelected?.forEach((calidadDenominacion) => {
      if (calidadDenominacion.importe > 0) {
        detallesDemanda.push({
          numCantidad: calidadDenominacion.importe,
          calidadDenominacion: calidadDenominacion,
        });
      }
    });
    if (
      this.clienteSelected &&
      this.delegationSelected &&
      this.divisaSelected &&
      this.costeSelected
    ) {
      this.demandaParams = {
        numCantidad: this.saldoDemandar,
        fecExpirar: new Date(this.fechaExpiracion + " " + this.horaExpiracion),
        checkAnonimo: this.anonimo,
        checkParcial: this.parcial,
        coste: this.costeSelected.id,
        pkDivisa: this.divisaSelected.id,
        pkCliente: this.clienteSelected.id!,
        pkDelegacion: this.delegationSelected.id,
        pkTransportadora: this.transportadoraSelected ? this.transportadoraSelected.id : undefined,
        detallesDemanda: detallesDemanda,
        numTasa: this.getNumTasa(this.clienteSelected, this.tasa),
        pkDelegaciones: this.delegationsIdsOptional,
        observacionesDemanda: this.demandaPaso4Params.observacionesDemanda,
        cuentaCorriente: this.demandaPaso4Params.cuentaCorriente || undefined,
        agNumeroSucursal: this.demandaPaso4Params.agNumeroSucursal || undefined,
        ispbBanco: this.demandaPaso4Params.ispbBanco || undefined,
        cnpjPersona: this.demandaPaso4Params.cnpjPersona || undefined,
      };

      if (this.ofertaDemanda && this.isEditar) {
        (this.demandaParams as any).id = this.ofertaDemanda.id;

        // Detectar cambios
        const { hasChanges, changes } = this.detectChanges(this.ofertaDemanda, this.demandaParams);

        if (hasChanges) {
          // Mostrar modal con los cambios detectados
          this.generateChangesHtml(changes);
          this.hasDetectedChanges = true;
        } else {
          this.changesHtmlContent = "";
          this.hasDetectedChanges = false;
        }
      }
    }
  }

  limpiarDemandaPaso4(): void {
    this.demandaPaso4Params.cuentaCorriente = "";
    this.demandaPaso4Params.agNumeroSucursal = "";
    this.demandaPaso4Params.ispbBanco = "";
    this.demandaPaso4Params.cnpjPersona = "";
    this.demandaPaso4Params.observacionesDemanda = "";
    this.demandaPaso4Params.relleno = false;
  }

  async demandar(): Promise<void> {
    this.$emit("action", { action: "demandarConfirm", data: this.demandaParams });
  }

  get titleLeftToDelegacionesOpcionales(): string {
    const textLeft = this.delegationSelected?.desDelegacion ?? "";
    const title = this.$t("label.delegaciones.opcionales.form").replace("X", textLeft);
    return this.$t(title);
  }

  calculaCantidad(calidadDenominacion?: ICalidadDenominacion): void {
    if (calidadDenominacion) {
      const result = mathjs.divide(
        calidadDenominacion.importe,
        calidadDenominacion.denominacion!.numValue
      );

      calidadDenominacion.cantidad = Number(mathjs.format(result, { precision: 14 }));
    }
  }

  calculaImporte(calidadDenominacion?: ICalidadDenominacion): void {
    if (calidadDenominacion) {
      const result = mathjs.multiply(
        calidadDenominacion.cantidad,
        calidadDenominacion.denominacion!.numValue
      );

      calidadDenominacion.importe = Number(mathjs.format(result, { precision: 14 }));
    }
  }

  private detectChanges(
    original: IOfertaDemanda,
    updated: IDemandaParams
  ): { hasChanges: boolean; changes: any } {
    const changes: Record<string, any> = {};
    let hasChanges = false;

    // Cantidad
    const originalCantidad = original.cantidadDemandada || original.cantidadDisponible;
    if (originalCantidad !== updated.numCantidad) {
      changes.cantidad = { anterior: originalCantidad, actual: updated.numCantidad };
      hasChanges = true;
    }

    // Fecha de expiracion
    if (original.fecExpirar && updated.fecExpirar) {
      const originalDate = new Date(original.fecExpirar);
      const updatedDate = new Date(updated.fecExpirar);
      if (originalDate.getTime() !== updatedDate.getTime()) {
        changes.fechaExpiracion = {
          anterior: originalDate.toLocaleString(),
          actual: updatedDate.toLocaleString(),
        };
        hasChanges = true;
      }
    }

    // Anonimo
    if (original.checkAnonimo !== updated.checkAnonimo) {
      changes.anonimo = { anterior: original.checkAnonimo, actual: updated.checkAnonimo };
      hasChanges = true;
    }

    // Parcial
    if (original.checkParcial !== updated.checkParcial) {
      changes.parcial = { anterior: original.checkParcial, actual: updated.checkParcial };
      hasChanges = true;
    }

    // Tasa
    if (this.clienteSelected && original.numTasa !== undefined && updated.numTasa !== undefined) {
      const originalTasa = this.getNumTasa(
        this.clienteSelected,
        Math.round(original.numTasa * 100000)
      );
      if (originalTasa !== undefined && this.existDifferenceInTasa(originalTasa, updated.numTasa)) {
        changes.tasa = { anterior: originalTasa, actual: updated.numTasa };
        hasChanges = true;
      }
    }

    // Divisa
    if (original.divisa.id !== updated.pkDivisa) {
      changes.divisa = {
        anterior: original.divisa.codDivisa,
        actual: this.divisaSelected?.codDivisa,
      };
      hasChanges = true;
    }

    // Delegacion
    if (original.clientexdel.delegacion.id !== updated.pkDelegacion) {
      changes.delegacion = {
        anterior: original.clientexdel.delegacion.desDelegacion,
        actual: this.delegationSelected?.desDelegacion,
      };
      hasChanges = true;
    }

    // Delegaciones Opcionales
    const originalDelegacionPrincipalId = original.clientexdel.delegacion.id;
    const updatedDelegacionPrincipalId = updated.pkDelegacion;

    const originalDelegacionesIds =
      original.ubicaciones
        ?.filter((ubicacion) => ubicacion.delegacion.id !== originalDelegacionPrincipalId)
        .map((ubicacion) => ubicacion.delegacion.id) || [];

    const updatedDelegacionesIds = (updated.pkDelegaciones || []).filter(
      (id) => id !== updatedDelegacionPrincipalId
    );

    const delegacionesAdded = updatedDelegacionesIds.filter(
      (id) => !originalDelegacionesIds.includes(id)
    );
    const delegacionesRemoved = originalDelegacionesIds.filter(
      (id) => !updatedDelegacionesIds.includes(id)
    );

    // Solo reportar si hay delegaciones agregadas o eliminadas
    if (delegacionesAdded.length > 0 || delegacionesRemoved.length > 0) {
      changes.delegacionesOpcionales = {};

      if (delegacionesAdded.length > 0) {
        changes.delegacionesOpcionales.agregadas = delegacionesAdded.map(
          (id) => this.delegationsOptions.find((del) => del.id === id)?.desDelegacion || ""
        );
      }

      if (delegacionesRemoved.length > 0) {
        changes.delegacionesOpcionales.eliminadas = delegacionesRemoved.map(
          (id) => this.delegationsOptions.find((del) => del.id === id)?.desDelegacion || ""
        );
      }

      hasChanges = true;
    }

    // Transportadora
    const originalTransportadoraId = original.transportadora?.id || null;
    const updatedTransportadoraId = updated.pkTransportadora || null;
    if (originalTransportadoraId !== updatedTransportadoraId) {
      changes.transportadora = {
        anterior: original.transportadora?.descripcion || this.$t("label.sin.transportadora"),
        actual: this.transportadoraSelected?.descripcion || this.$t("label.sin.transportadora"),
      };
      hasChanges = true;
    }

    // Coste
    if (original.coste.id !== updated.coste) {
      changes.coste = {
        anterior: original.coste.codParametro,
        actual: this.costeSelected?.codParametro,
      };
      hasChanges = true;
    }

    // Observaciones
    if ((original.observaciones || "") !== (updated.observacionesDemanda || "")) {
      changes.observaciones = {
        anterior: original.observaciones || this.$t("label.sin.observaciones"),
        actual: updated.observacionesDemanda || this.$t("label.sin.observaciones"),
      };
      hasChanges = true;
    }

    // Detalles de la demanda - Denominaciones
    if (original.detallesDemanda && updated.detallesDemanda) {
      const detailChanges = this.compareDetallesDemanda(
        original.detallesDemanda,
        updated.detallesDemanda
      );
      if (detailChanges.hasChanges) {
        changes.denominaciones = detailChanges.changes;
        hasChanges = true;
      }
    }

    return { hasChanges, changes };
  }

  existDifferenceInTasa(originalTasa: number, updatedTasa: number): boolean {
    const diff = Math.abs(originalTasa - updatedTasa);
    const diffRounded = Number(diff.toFixed(5));
    return diffRounded > 0.00001;
  }

  compareDetallesDemanda(
    originalDetails: any[],
    updatedDetails: IDetalleDemandaParams[]
  ): { hasChanges: boolean; changes: any[] } {
    const changes: any[] = [];
    let hasChanges = false;

    // Crear mapas para comparacion eficiente
    const originalMap = new Map();
    originalDetails?.forEach((detail) => {
      originalMap.set(detail.soCalidadDenominacion?.id, detail.cantidadDemandada);
    });

    const updatedMap = new Map();
    updatedDetails.forEach((detail) => {
      updatedMap.set(detail.calidadDenominacion.id, detail.numCantidad);
    });

    // Comparar cantidades
    originalMap.forEach((originalAmount, denominacionId) => {
      const updatedAmount = updatedMap.get(denominacionId) || 0;
      if (Math.abs(originalAmount - updatedAmount) > 0.001) {
        changes.push({
          denominacionId,
          anterior: originalAmount,
          actual: updatedAmount,
          denominacion: this.getDenominacionDescription(denominacionId),
        });
        hasChanges = true;
      }
    });

    // Verificar nuevas denominaciones
    updatedMap.forEach((updatedAmount, denominacionId) => {
      if (!originalMap.has(denominacionId) && updatedAmount > 0) {
        changes.push({
          denominacionId,
          anterior: 0,
          actual: updatedAmount,
          denominacion: this.getDenominacionDescription(denominacionId),
          esNueva: true,
        });
        hasChanges = true;
      }
    });

    return { hasChanges, changes };
  }

  getDenominacionDescription(denominacionId: number): string {
    // Buscar en calidadesDenominacionSelected o calidadesDenominacion
    const detalleSelected = this.calidadesDenominacionSelected?.find(
      (d) => d.id === denominacionId
    );
    if (detalleSelected && detalleSelected.denominacion) {
      return `${detalleSelected.denominacion.codDenominacion} ${detalleSelected.desCalidad}`;
    }

    const calidad = this.calidadesDenominacion.find((c) => c.id === denominacionId);
    if (calidad && calidad.denominacion) {
      return `${calidad.denominacion.codDenominacion} ${calidad.desCalidad}`;
    }

    return "";
  }

  async loadDetallesDemandaForEdit(): Promise<void> {
    const detalleFromDemanda = this.ofertaDemanda?.detallesDemanda;
    if (!detalleFromDemanda?.length) return;

    const detallesValidos = detalleFromDemanda.filter((detalle) => detalle.soCalidadDenominacion);

    if (this.clienteSelected?.fakeCerts) {
      this.processDetallesForFakeCerts(detallesValidos);
    } else {
      await this.searchSaldosActuales();
      this.processDetallesForSaldos(detallesValidos);
    }
  }

  processDetallesForFakeCerts(detalles: any[]): void {
    detalles.forEach((detalle) => {
      const detalleMatch = this.calidadesDenominacion.find(
        (calidad) => calidad.id === detalle.soCalidadDenominacion?.id
      );

      if (detalleMatch) {
        this.updateDetalleDemandaMatch(detalleMatch, detalle);
        this.calidadesDenominacionSelected?.push(detalleMatch);
      }
    });
  }

  processDetallesForSaldos(detalles: any[]): void {
    detalles.forEach((detalle) => {
      const detalleMatch = this.detallesSaldo?.find(
        (detSaldo) => detSaldo.calidadDenominacion?.id === detalle.soCalidadDenominacion?.id
      );
      if (detalleMatch?.calidadDenominacion) {
        this.updateDetalleDemandaMatch(detalleMatch.calidadDenominacion, detalle);
        this.calidadesDenominacionSelected?.push(detalleMatch.calidadDenominacion);
      }
    });
  }

  updateDetalleDemandaMatch(target: any, source: any): void {
    this.$set(target, "importe", source.cantidadDemandada);
    this.$set(target, "importeSelected", false);
    this.$set(target, "denominacion", source.soCalidadDenominacion?.denominacion);
    this.$set(target, "cantidadSelected", false);
    this.calculaCantidad(target);
  }

  generateChangesHtml(changes: Record<string, any>): void {
    // Validación de entrada
    if (!changes || Object.keys(changes).length === 0) {
      this.changesHtmlContent = "";
      return;
    }

    let htmlContent = '<div class="text-left">';

    Object.entries(changes).forEach(([field, change]) => {
      if (field === "denominaciones") {
        htmlContent += `<div class="mb-2"><strong>${this.$t(
          "label.denominaciones"
        )}:</strong></div>`;
        htmlContent += '<ul class="list-unstyled ml-3">';
        change.forEach((denom: any) => {
          const anteriorFormat = this.filterNumber(denom.anterior);
          const actualFormat = this.filterNumber(denom.actual);
          const status = denom.esNueva
            ? ` <span class="badge badge-success">${this.$t("label.nueva")}</span>`
            : "";
          htmlContent += `<li>• ${denom.denominacion}: <span class="text-muted">${anteriorFormat}</span> - <strong>${actualFormat}</strong>${status}</li>`;
        });
        htmlContent += "</ul>";
      } else if (field === "delegacionesOpcionales") {
        htmlContent += `<div class="mb-2"><strong>${this.$t(
          "label.delegaciones.opcionales"
        )}:</strong></div>`;
        htmlContent += '<ul class="list-unstyled ml-3">';

        // Solo mostrar delegaciones agregadas
        if (change.agregadas && change.agregadas.length > 0) {
          change.agregadas.forEach((del: string) => {
            htmlContent += `<li>• ${del} <span class="badge badge-success">${this.$t(
              "label.agregada"
            )}</span></li>`;
          });
        }

        // Solo mostrar delegaciones eliminadas
        if (change.eliminadas && change.eliminadas.length > 0) {
          change.eliminadas.forEach((del: string) => {
            htmlContent += `<li>• ${del} <span class="badge badge-danger">${this.$t(
              "label.eliminada"
            )}</span></li>`;
          });
        }
        htmlContent += "</ul>";
      } else if (field === "anonimo" || field === "parcial") {
        const fieldName = this.getFieldDisplayName(field);
        const anteriorText = change.anterior ? this.$t("label.si") : this.$t("label.no");
        const actualText = change.actual ? this.$t("label.si") : this.$t("label.no");
        htmlContent += `<div class="mb-2"><strong>${fieldName}:</strong> <span class="text-muted">${anteriorText}</span> - <strong>${actualText}</strong></div>`;
      } else if (field === "cantidad") {
        const fieldName = this.getFieldDisplayName(field);
        const anteriorFormat = this.filterNumber(change.anterior);
        const actualFormat = this.filterNumber(change.actual);
        htmlContent += `<div class="mb-2"><strong>${fieldName}:</strong> <span class="text-muted">${anteriorFormat}</span> - <strong>${actualFormat}</strong></div>`;
      } else {
        const fieldName = this.getFieldDisplayName(field);
        htmlContent += `<div class="mb-2"><strong>${fieldName}:</strong> <span class="text-muted">${change.anterior}</span> - <strong>${change.actual}</strong></div>`;
      }
    });

    htmlContent += "</div>";
    this.changesHtmlContent = htmlContent;
  }

  getFieldDisplayName(field: string): string {
    const displayNames: Record<string, string> = {
      cantidad: this.$t("label.cantidad"),
      fechaExpiracion: this.$t("label.fecha.expiracion"),
      anonimo: this.$t("label.demanda.anonima"),
      parcial: this.$t("label.demanda.parcial"),
      tasa: this.$t("label.tasa"),
      divisa: this.$t("label.divisa"),
      delegacion: this.$t("label.delegacion"),
      transportadora: this.$t("label.transportadora"),
      coste: this.$t("label.coste"),
      observaciones: this.$t("label.observaciones"),
      delegacionesOpcionales: this.$t("label.delegaciones"),
    };

    return displayNames[field] || field;
  }

  clearChangesState(): void {
    this.hasDetectedChanges = false;
    this.changesHtmlContent = "";
  }

  get isEditar(): boolean {
    return this.actionSource === ActionOnOfertaDemanda.EDITAR;
  }

  get demandaDescription(): string {
    return this.isEditar
      ? this.$t("label.demandar.fondos.confirmacion.modificar")
      : this.$t("label.aviso.demanda");
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  line-height: 40px;
  color: var(--secundario-prosegur-claro);
}

.btn-number {
  border-color: transparent;
  background-color: #ffd102;
}

.separator {
  border-right-color: gainsboro;
  border-right-style: solid;
  border-right-width: 1px;
}

.carousel-transferencias {
  padding: 0 0.75rem;
}

.detalle-transferencias {
  padding-right: 0.5rem;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}

.textarea {
  height: 150px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
}

.modal-transferencias-footer {
  position: absolute;
  bottom: 0;
  right: 1rem;
}

.resumen {
  min-height: 13rem;
  margin: -2.6rem -1rem 2rem;
  background-color: var(--amarillo-prosegur);
}

.panel-denominaciones {
  overflow: auto;
  max-height: 55vh;
}
.btn-group-toggle::v-deep .btn-outline-primary {
  border-radius: 6px !important;
}
.resume-label {
  font-size: 13px;
  display: block;
  color: var(--secundario-prosegur-claro);
}
.label-15 {
  font-size: 15px;
  color: var(--secundario-prosegur-claro);
}
.label-17 {
  font-size: 17px;
  color: var(--secundario-prosegur-oscuro);
}
.label-21 {
  font-size: 17px;
  color: var(--secundario-prosegur-oscuro);
}
.label-demandado {
  display: flex;
  align-items: flex-end;
  justify-content: right;
}
.container_DemandarForm {
  min-height: 300px;
}
.form_DemandarForm {
  padding: 1rem;
}
.label_TitleLeftToDelegacionesOpcionales {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
  cursor: pointer;
}
.error-divisa {
  color: #dc3545;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
}
.radio-form-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  flex-direction: row;
  flex-wrap: wrap;
}
.form-radio {
  flex: none !important;
  margin-bottom: 10px;
}
.changes-content {
  .changes-list {
    max-height: 300px;
    overflow-y: auto;
  }

  .badge {
    font-size: 0.75em;
  }

  .text-muted {
    text-decoration: line-through;
  }

  .alert-heading {
    color: var(--secundario-prosegur-oscuro) !important;
    font-weight: 600 !important;
    margin-bottom: 1rem !important;
    font-size: 1rem !important;
  }
}
::v-deep .description_PConfirm {
  max-width: 600px !important;
  padding-bottom: 1rem !important;
}
</style>
